<div class="confirm-clone-or-move-wrapper sp-mt-32">
  <img class="sp-mb-32" src="/dist/img/cannot-continue.svg" alt="Confirm cloning/moving" />
  <p *ngIf="isMethodClone && customFieldsCount === 1">
    {{
      "confirm_clone_goal_or_metric_with_custom_field"
        | localize
          : {
              invokerType: message
            }
    }}
  </p>
  <p *ngIf="isMethodClone && customFieldsCount > 1">
    {{
      "confirm_clone_goal_or_metric_with_custom_fields"
        | localize
          : {
              invokerType: message
            }
    }}
  </p>
  <p *ngIf="!isMethodClone && customFieldsCount === 1">
    {{
      "confirm_move_goal_or_metric_with_custom_field"
        | localize
          : {
              invokerType: message
            }
    }}
  </p>
  <p *ngIf="!isMethodClone && customFieldsCount > 1">
    {{
      "confirm_move_goal_or_metric_with_custom_fields"
        | localize
          : {
              invokerType: message
            }
    }}
  </p>
</div>
